"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _theme = require("../theme");
require("./rule.css");
var _excluded = ["className", "visualStyle", "weight"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A `horizontal rule` element. Padding and margin can both be applied to the component or its siblings.
 */
var Rule = function Rule(_ref) {
  var className = _ref.className,
    visualStyle = _ref.visualStyle,
    weight = _ref.weight,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_theme.ThemeContext.Consumer, null, function (theme) {
    var useLightRule = visualStyle === 'negative' || theme === _theme.themes.dark;
    var useLightGreenRule = visualStyle === 'lightGreen';
    return /*#__PURE__*/_react["default"].createElement("hr", _extends({
      "aria-hidden": "true",
      className: (0, _classnames["default"])('sb-rule', _defineProperty({
        'sb-rule--negative': useLightRule,
        'sb-rule--thin': weight === 'thin',
        'sb-rule--thick': weight === 'thick' || useLightGreenRule,
        'sb-rule--lightGreen': useLightGreenRule
      }, className, Boolean(className)))
    }, otherProps));
  });
};
Rule.displayName = 'Rule';
Rule.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Negative: Change the color to transparent white if Rule is on a dark background.
   * LightGreen: Change the color to Light Green and apply thickness to it as well.
   * Default is transparent black.
   */
  visualStyle: _propTypes["default"].oneOf(['negative', 'lightGreen']),
  /**
   * Change the weight (thickness) of the Rule. Thin is 1 pixel. Thick is 4 pixels with rounded corners. Default is 2 pixels.
   */
  weight: _propTypes["default"].oneOf(['thin', 'thick'])
} : {};
var _default = exports["default"] = Rule;